import { useMemo } from 'react';
import { Alert, Box, styled } from '@mui/material';

import { useListAgents } from '@api';
import RerunInstallationButton from './RerunInstallationButton';
import { useHasPermission } from '@hooks';
import { Permission } from '@common/utils/admin_permissions';

const BannerWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 6, 0),
}));

export default function LocalConnectorFailedBanner() {
  const { connectors } = useListAgents(true);
  const hasConnectorPermission = useHasPermission([Permission.CONNECTORS_WRITE]);

  const failedLocalConnector = useMemo(
    () =>
      connectors.find(
        (connector) => connector.cloud_provider?.local_deploy && connector.status.toLowerCase() === 'disconnected',
      ),
    [connectors],
  );

  if (!failedLocalConnector) return null;

  return (
    <BannerWrapper>
      <Alert severity="error" action={hasConnectorPermission && <RerunInstallationButton />}>
        Connector <strong>{failedLocalConnector.name}</strong> is down.
      </Alert>
    </BannerWrapper>
  );
}
